export class SavedSearch {
    id: number = -1;

    entity: string = '';
    data:string = '';
    name: string = '';
  
    createdAt: string = '';
    updatedAt: string = '';
  
}